import React from 'react';
import './AboutPreview.css';

const AboutPreview = () => {
  return (
    <section id="about-preview" className="about-preview section">
      <div className="container">
        <div className="section-header animate-on-scroll">
          <span className="section-label">About Us</span>
          <h2>At a Glance</h2>
        </div>
        <div className="about-content animate-on-scroll">
          <p>Established in 1979, Xavier & Xavier is a trusted regional firm headquartered in Tuticorin with a branch in Chennai. We bridge the gap between management expectations and on-ground realities by offering strategic, audit-focused, and technology-driven solutions across finance, risk, controls, and information security.</p>
          <p><strong>Our commitment is simple:</strong> professional excellence, reliable delivery, and long-term value for every client we serve.</p>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
